import React from 'react';
import PropTypes from 'prop-types';
import {
    PlayerDuelWrapper
} from './FieldVisionPlayerDuel.style';
import {
    MatchupStateWrapper,
    MatchupWrapper
} from './PlayerDuel.style';
import UpcomingBatters from './components/UpcomingBatters/UpcomingBatters';
import Outs from './components/Outs';
import { liveViewsTypes } from '../themes/liveViewsTypes';
import buildMatchupState from './utils/buildMatchupState';
import BasePathComponent, { BASEPATH_MOBILE_WIDTH, BASEPATH_WIDTH } from './components/BasePathComponent';
import MatchupsList from './components/MatchupsList';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';
import useMedia from '@gameday/utils/hooks/useMedia';

const { SM_MIN, SM_REG_MAX } = GDBREAKPOINTS;
const { SINGLENARROW, FULLNARROW } = liveViewsTypes;

const FieldVisionPlayerDuel = ({
    probablePitchers,
    abstractGameCode,
    batter,
    inHole,
    onDeck,
    first,
    second,
    third,
    pitcher,
    balls,
    strikes,
    outs,
    showUpcomingBatters = true,
    gameStateOverride,
    stacked,
    deviceInteraction,
    usePreviousPlayers
}) => {
    const isSingleWide = useMedia(`(min-width: ${SM_MIN}) and (max-width: ${SM_REG_MAX})`);
    let viewType;

    if (isSingleWide) {
        viewType = FULLNARROW;
    } else {
        viewType = SINGLENARROW;
    }

    const gameCodeOverride = gameStateOverride || abstractGameCode;
    const matchupState = buildMatchupState({ gameCodeOverride, balls, strikes });
    const isPreview = gameCodeOverride === 'P';
    const basepaths = { first: !!first?.person, second: !!second?.person, third: !!third?.person };
    const $gameState = isPreview ? 'preview' : '';
    const headshotWidth = (viewType === FULLNARROW) ? '64px' : '48px';
    const matchupsArray = MatchupsList({
        probablePitchers,
        abstractGameCode,
        batter,
        pitcher,
        gameStateOverride,
        stacked,
        deviceInteraction,
        usePreviousPlayers,
        viewType,
        isMobile: true,
        isFullNarrow: false,
        headshotWidth
    });

    const outWidth = isSingleWide ? BASEPATH_WIDTH : BASEPATH_MOBILE_WIDTH;

    return (
        <>
            <PlayerDuelWrapper $gameState={$gameState} $type={viewType}>
                { matchupsArray.length && (
                    <MatchupWrapper $gameState={$gameState} $showUpcomingBatters={showUpcomingBatters} $type={viewType}>
                        { matchupsArray[0] }
                        <MatchupStateWrapper $gameState={$gameState} $type={viewType}>
                            {!isPreview && <BasePathComponent {...basepaths} width={outWidth} />}
                            <span>{matchupState}</span>
                            {!isPreview && <Outs outCount={outs} outWidth={outWidth} />}
                        </MatchupStateWrapper>
                        { matchupsArray[1] }
                    </MatchupWrapper>
                )}
            </PlayerDuelWrapper>
            { showUpcomingBatters && !isPreview && <UpcomingBatters inHole={ inHole } onDeck={ onDeck } isMobile={true} /> }
        </>
    );
};

FieldVisionPlayerDuel.propTypes = {
    data: PropTypes.object,
    probablePitchers: PropTypes.object,
    abstractGameCode: PropTypes.string,
    batter: PropTypes.object,
    inHole: PropTypes.object,
    onDeck: PropTypes.object,
    first: PropTypes.bool,
    second: PropTypes.bool,
    third: PropTypes.bool,
    pitcher: PropTypes.object,
    balls: PropTypes.string,
    strikes: PropTypes.string,
    outs: PropTypes.number,
    showUpcomingBatters: PropTypes.bool,
    gameStateOverride: PropTypes.string,
    stacked: PropTypes.bool,
    deviceInteraction: PropTypes.object,
    usePreviousPlayers: PropTypes.bool
};

export default FieldVisionPlayerDuel;
